import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Auth } from 'aws-amplify';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import FormInputText from '../../common/Forms/FormTextField';
import moment from 'moment';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputDropdown from '../../common/Forms/InputDropdown';
import { useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import {
  EPISODE_REFERRAL_URL,
  formDateFormat,
  EPISODE_REFERRAL_UPDATE_URL,
  yesNoDropdown,
  AUTHORIZATION_REPORTS_REFERRAL_URL,
} from '../../../constants';
import {
  setDateReferralSentFromSAP,
  setDateofSAPOrJailRelease,
  setCountyofParoleId,
  setDrugTreatmentProgramTransitionCoordinatorId,
  setDateReferralSenttoSAP,
  setSTOPPlacementCoordinatorId,
  setEpdIcnDateRelExp,
  setSTOPResponse,
  setClinicalInformationTreatmentRecommendations,
  setEpdIrydsc,
  setIsReferralDataLoaded,
  getReferralForm,
} from '../../../redux/episode/referralTab/referralFormSlice';
import { setStopApi, deleteStopApi } from '../../../services/StopApi/StopApi';
import FormSuccess from '../../common/Forms/FormSuccess';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import CancelPopUp from '../../common/CancelPopUp/CancelPopUp';
import { setRefreshEpisodeParticipant } from '../../../redux/episode/episodeParticipant/episodeParticipantSlice';
import { getSaveCancel } from '../../common/commonUtils/commonUtils';
import { DataGridContainer, PrintButtonGrid, LeftGrid, DialogHeader, DialogHeading } from '../Episode.Styled';
import { CommonDropDownStyle } from '../../ui/styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InitialReferalPage from './InitialReferalPage';
import { getReferalPdfForm } from '../../../redux/episode/referralTab/referalTabPdf/referalPdfSlice';
import { getContactByUser } from '../../Contact/services/contactsApi';
import DeleteIcon from '@mui/icons-material/Delete';

const Referral = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [formLoading, setFormLoading] = useState(true);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [initialReferalPage, setinitialReferalPage] = useState(false);
  const [openReferralDialog, setOpenReferralDialog] = useState(false);
  const [modality, setModality] = useState(null);
  const [provider, setProvider] = useState(null);
  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const referralForm = useSelector((state) => state?.referralForm);
   //console.log('### referralForm');
   //console.log(referralForm);

  const referralRefernceData = useSelector(
    (state) => state?.referralRefernceData
  );
  // console.log('### referralRefernceData');
  // console.log(referralRefernceData);

  const authReferenceData = useSelector((state) => state?.authReferenceData);
  //console.log('### authReferenceData');
  //console.log(authReferenceData);

  const [filterProviderList, setFilterProviderList] = useState(
    authReferenceData?.communityBasedProviderList
  );
  //console.log('### filterProviderList');
  //console.log(filterProviderList);

  const defaultValue = {
    dateReferralSentFromSAP: moment(
      referralForm?.dateReferralSentFromSAP
    ).format(formDateFormat),
    dateofSAPOrJailRelease: moment(referralForm?.dateofSAPOrJailRelease).format(
      formDateFormat
    ),
    countyofParoleId: referralForm?.countyofParoleId
      ? referralForm?.countyofParoleId
      : '',
    drugTreatmentProgramTransitionCoordinatorId:
      referralForm?.drugTreatmentProgramTransitionCoordinatorId
        ? referralForm?.drugTreatmentProgramTransitionCoordinatorId
        : '',
    dateReferralSenttoSAP: moment(referralForm?.dateReferralSenttoSAP).format(
      formDateFormat
    ),
    sTOPPlacementCoordinatorId: referralForm?.sTOPPlacementCoordinatorId
      ? referralForm?.sTOPPlacementCoordinatorId
      : '',
    epdIcnDateRelExp: moment(referralForm?.epdIcnDateRelExp).format(
      formDateFormat
    ),
    sTOPResponse:
      referralForm?.sTOPResponse === null ? '' : referralForm?.sTOPResponse,
    clinicalInformationTreatmentRecommendations:
      referralForm?.clinicalInformationTreatmentRecommendations,
    epdIrydsc: referralForm?.epdIrydsc,
  };

  const useFunction = useForm({ defaultValues: defaultValue });
  const { handleSubmit, reset, control, watch, register } = useFunction;

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  useEffect(() => {
    setProvider('');
    if (modality) {
      setFilterProviderList(
        authReferenceData?.communityBasedProviderList.filter((c) =>
          c?.value?.includes(modality)
        )
      );
    }
    else {
      setFilterProviderList([]);
    }
  }, [modality]);  


  const fetchData = async () => {
    let referralTabUrl = `${EPISODE_REFERRAL_URL}/${episodeId}/reference`;
    const cmpReferralUrl = `${AUTHORIZATION_REPORTS_REFERRAL_URL}${episodeId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    //if (referralForm?.isReferralDataLoaded === false) {
      dispatch(getReferralForm({ referralTabUrl, authorization }));
      dispatch(getReferalPdfForm({ cmpReferralUrl, authorization }));
      setTimeout(() => {
        dispatch(setIsReferralDataLoaded(true));
      }, 1000);
    //}
    setTimeout(() => {
      setFormLoading(false);
    }, 500);
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(function (user) {
        getContactByUser(user)
          .then(function (loggedInContact) {
            user.contact = loggedInContact;
          })
          .catch(() => console.log('Not signed in'));
        return user;
      })
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.dateReferralSentFromSAP,
    defaultValue.dateofSAPOrJailRelease,
    defaultValue.countyofParoleId,
    defaultValue.drugTreatmentProgramTransitionCoordinatorId,
    defaultValue.dateReferralSenttoSAP,
    defaultValue.sTOPPlacementCoordinatorId,
    defaultValue.epdIcnDateRelExp,
    defaultValue.sTOPResponse,
    defaultValue.clinicalInformationTreatmentRecommendations,
    defaultValue.epdIrydsc,
  ]);

  const onSubmit = () => {
    const url = EPISODE_REFERRAL_UPDATE_URL;
    const payload = {
      episodeID: episodeId,
      dateReferralSentFromSAP: referralForm?.dateReferralSentFromSAP,
      dateofSAPOrJailRelease: referralForm?.dateofSAPOrJailRelease,
      clinicalInformationTreatmentRecommendations:
        referralForm?.clinicalInformationTreatmentRecommendations,
      sTOPResponse:
        referralForm?.sTOPResponse === '' ? null : referralForm?.sTOPResponse,
      epdIcnDateRelExp: referralForm?.epdIcnDateRelExp,
      mim12Step: referralForm?.mim12Step ? referralForm?.mim12Step : null,
      mim12StepLocation: referralForm?.mim12StepLocation
        ? referralForm?.mim12StepLocation
        : null,
      epdIrydsc: referralForm?.epdIrydsc,
      receivedCBPROI: referralForm?.receivedCBPROI,
      receivedSAPROI: referralForm?.receivedSAPROI,
      dateReferralSenttoSAP: referralForm?.dateReferralSenttoSAP,
      initialAuthNumberDays: referralForm?.initialAuthNumberDays
        ? referralForm?.initialAuthNumberDays
        : null,
      initialAuthExpectedEndDate: referralForm?.initialAuthExpectedEndDate
        ? referralForm?.initialAuthExpectedEndDate
        : null,
      countyofParoleId: referralForm?.countyofParoleId
        ? referralForm?.countyofParoleId
        : null,
      drugTreatmentProgramTransitionCoordinatorId:
        referralForm?.drugTreatmentProgramTransitionCoordinatorId
          ? referralForm?.drugTreatmentProgramTransitionCoordinatorId
          : null,
      sTOPPlacementCoordinatorId: referralForm?.sTOPPlacementCoordinatorId
        ? referralForm?.sTOPPlacementCoordinatorId
        : null,
    };
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        setFormSuccess(true);
        dispatch(setRefreshEpisodeParticipant(true));
        setTimeout(() => {
          dispatch(setRefreshEpisodeParticipant(false));
        }, 1000);
      }
    }).catch((e) => alert(e));
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  if (formLoading) {
    return <ProgressBar />;
  }

const handleNewReferral = () => {
  setOpenReferralDialog(true);
};

const handleDeleteReferral = async (params) => {
  //console.log('### params');
  //console.log(params);
  const url = `${EPISODE_REFERRAL_URL}/episode/ref/${params.id}`;
  const payload = {};
  const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

  deleteStopApi({ url, payload, authorization }).then((response) => {
    console.log('### delete response')
    console.log(response)
    fetchData();
  }).catch((e) => alert(e));  
};

const handleClose = (params) => {
    setOpenReferralDialog(false);
    setModality('');
};

const handleAddRef = () => {
  const url = `${EPISODE_REFERRAL_URL}/${episodeId}/episode/ref`;
  const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
  const payload = {
    'refId': 0,
    'refEpdId': episodeId,
    'refCboId': provider,
    'refMod': modality,
    'refEditCntId': user?.contact?.cntId
  }
  //console.log('### payload');
  //console.log(payload);

  setStopApi({ url, payload, authorization }).then((response) => {
    console.log('### add ref response')
    console.log(response)
    fetchData();
    handleClose();
  }).catch((e) => alert(e));
}

const refCols = [
    {
      field: 'actions',
      headerName: '',
      //type: 'actions',
      renderCell: (params) => {
        return (
          <IconButton 
            onClick={() => handleDeleteReferral(params)}
          >
            <DeleteIcon />
          </IconButton>
        );
      },
    },
      {
        field: 'refMod',
        headerName: 'Modality',
        sortable: false,
        flex: 1,
      },
      {
        field: 'refCboId',
        headerName: 'Provider',
        sortable: false,
        flex: 1,
      },
      {
        field: 'refContact',
        headerName: 'Provider Referral Contact',
        sortable: false,
        flex: 1,
      },
      {
        field: 'refContactFax',
        headerName: 'Fax',
        sortable: false,
        flex: 1,
      },
      {
        field: 'refContactPhone',
        headerName: 'Phone',
        sortable: false,
        flex: 1,
      },
      {
        field: 'refId',
        headerName: 'refID',
        sortable: false,
        flex: 1,
      },
  ];
    
  return (
    <>
      <PrintButtonGrid container>
        <Grid item>
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                setinitialReferalPage(true);
              }}
            >
              Print View
            </Button>
          </Box>
        </Grid>
      </PrintButtonGrid>
      <Grid
        container
        spacing={3}
        style={{ justifyContent: 'center', marginTop: '0px' }}
      >
        <Grid item xs={12} sm={4}>
          <FormInputText
            name="dateReferralSentFromSAP"
            type="date"
            control={control}
            shrink={true}
            label="Date Referral Sent From Sap"
            register={register('dateReferralSentFromSAP', {
              onChange: (e) =>
                dispatch(setDateReferralSentFromSAP(e.target.value)),
            })}
          />
          <FormInputText
            name="dateofSAPOrJailRelease"
            type="date"
            control={control}
            shrink={true}
            label="Date of Sap Jail Release"
            register={register('dateofSAPOrJailRelease', {
              onChange: (e) =>
                dispatch(setDateofSAPOrJailRelease(e.target.value)),
            })}
          />
          <InputDropdown
            name="countyofParoleId"
            control={control}
            options={referralRefernceData?.paroleCounties}
            defaultId={defaultValue?.countyofParoleId}
            register={register('countyofParoleId', {
              onChange: (e) => dispatch(setCountyofParoleId(e.target.value)),
            })}
            label="County Of Parole"
          />

          <InputDropdown
            name="drugTreatmentProgramTransitionCoordinatorId"
            control={control}
            options={
              referralRefernceData?.drugTreatmentProgramTransitionCoordinators
            }
            defaultId={
              defaultValue?.drugTreatmentProgramTransitionCoordinatorId
            }
            valueAsKey={true}
            register={register('drugTreatmentProgramTransitionCoordinatorId', {
              onChange: (e) =>
                dispatch(
                  setDrugTreatmentProgramTransitionCoordinatorId(e.target.value)
                ),
            })}
            label="Drug Treatement Program Coordinator"
          />
          <FormInputText
            name="dateReferralSenttoSAP"
            type="date"
            control={control}
            shrink={true}
            label="Date Referral Sent to Sap"
            register={register('dateReferralSenttoSAP', {
              onChange: (e) =>
                dispatch(setDateReferralSenttoSAP(e.target.value)),
            })}
          />
          <InputDropdown
            name="sTOPPlacementCoordinatorId"
            control={control}
            options={referralRefernceData?.stopPlacementCoordinators}
            defaultId={defaultValue?.sTOPPlacementCoordinatorId}
            valueAsKey={true}
            register={register('sTOPPlacementCoordinatorId', {
              onChange: (e) =>
                dispatch(setSTOPPlacementCoordinatorId(e.target.value)),
            })}
            label="STOP Placement Coordinator"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name="epdIcnDateRelExp"
            type="date"
            control={control}
            shrink={true}
            label="Conditional Treatment Slot Date"
            register={register('epdIcnDateRelExp', {
              onChange: (e) => dispatch(setEpdIcnDateRelExp(e.target.value)),
            })}
          />
          <InputDropdown
            name="sTOPResponse"
            control={control}
            options={yesNoDropdown}
            register={register('sTOPResponse', {
              onChange: (e) => dispatch(setSTOPResponse(e.target.value)),
            })}
            label="Stop Response"
          />
          <FormInputText
            name="clinicalInformationTreatmentRecommendations"
            type="text"
            control={control}
            multiline={true}
            rows={3.5}
            label="Clinical Information"
            register={register('clinicalInformationTreatmentRecommendations', {
              onBlur: (e) => {
                //alert(e.target.value)
                dispatch(setClinicalInformationTreatmentRecommendations(e.target.value))
              },
            })}
          />
          <FormInputText
            name="epdIrydsc"
            type="text"
            control={control}
            multiline={true}
            rows={3.5}
            label="Additional Information"
            register={register('epdIrydsc', {
              onBlur: (e) => {
                //alert(e.target.value)
                dispatch(setEpdIrydsc(e.target.value))
              },
            })}
          />
        </Grid>
      </Grid>
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
      <FormSuccess formSuccess={formSuccess} setFormSuccess={setFormSuccess} />
      <CancelPopUp cancelPopUp={cancelPopUp} setCancelPopUp={setCancelPopUp} />
      <InitialReferalPage
        open={initialReferalPage}
        setOpen={setinitialReferalPage}
        referralForm={referralForm}
        user={user}
      />

      <hr />
      <Typography variant="h4" textAlign='center'>Referrals</Typography>
      <Box py={2}>
        <Grid>
          <LeftGrid item xs={6}>
            <Button
              sx={{marginBottom: '6px;'}}
              //disabled={!defaultValue.authIsLocked || cbpData?.data?.length > 0}
              variant="contained"
              onClick={() => handleNewReferral()}
            >
              New Referral
            </Button>
          </LeftGrid>
        </Grid>  
        <DataGridContainer>
          <DataGrid
            getRowHeight={() => 'auto'}
            columns={refCols}
            rows={referralForm.tblRefs ?? []}
            //columns={cbpColumnsData}
            //rows={cbpData.data}
            //rowCount={cbpData.total}
            getRowId={(row) => row.refId}
            //rowsPerPageOptions={[10, 25, 50]}
            //pageSize={cbpData.pageSize}
            //pagination
            //paginationMode="server"
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? 'even'
                : 'odd'
            }
            //onRowClick={(param) => cbpAuthRowClick(param.row)}
            disableColumnFilter
            disableColumnMenu
          />
        </DataGridContainer>
      </Box>        

    <Dialog
        open={openReferralDialog}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '800px',
            maxHeight: 'unset',
          },
        }}
      >
      <>
        <DialogHeader>
            <DialogHeading variant='h5'></DialogHeading>
            <DialogHeading variant='h5'>Episode Referral</DialogHeading>
            <Box>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogHeader>
          <Grid container style={{ padding: '10px 40px' }}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <CommonDropDownStyle>
                  <InputLabel id="county">Modality</InputLabel>
                  <Select
                    labelId="modality"
                    id="modality"
                    value={modality}
                    label="Modality"
                    onChange={(event) => {
                      setModality(event.target.value);
                    }}
                  >
                  {
                    authReferenceData?.modalityList?.map((item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item.modId}
                        >
                          {item.modDsc}
                        </MenuItem>
                      )                  
                    })
                  }  
                  </Select>
                </CommonDropDownStyle>  
              </Grid>            
              <Grid item xs={9}>
                <CommonDropDownStyle>
                  <InputLabel id="county">Provider</InputLabel>
                  <Select
                    labelId="provider"
                    id="provider"
                    value={provider}
                    label="Provider"
                    onChange={(event) => {
                      setProvider(event.target.value);
                    }}
                  >
                  {
                    filterProviderList?.map((item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item.id}
                        >
                          {item.value}
                        </MenuItem>
                      )                  
                    })
                  }  
                  </Select>
                </CommonDropDownStyle>  
              </Grid>
              <Button
                variant="contained"
                onClick={() => handleClose()}
              >
                Cancel
              </Button>&nbsp;            
              <Button
                disabled={!modality || !provider}
                variant="contained"
                onClick={() => handleAddRef()}
              >
                Add Referral
              </Button>            
            </Grid>
          </Grid>  

      </>
    </Dialog>

    </>



  );
};
export default Referral;
